import { callCollaboratorsApi } from './collaboratorsApi';

export interface CollaboratorInfo {
  uid: string;
  email: string | null;
  displayName: string | null;
}

interface GetCollaboratorsResult {
  tourId: string;
  ownerUid: string;
  /** May be null if the owner's auth record can't be resolved. */
  owner: CollaboratorInfo | null;
  collaborators: CollaboratorInfo[];
}

export async function getCollaborators(
  tourId: string,
): Promise<GetCollaboratorsResult> {
  return callCollaboratorsApi<GetCollaboratorsResult>({
    action: 'list',
    tourId,
  });
}
